import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import scss from './ReactionsButtonGroup.scss';

export const TARGETED_REACTION_TIMEOUT = 5000;
export const FADE_TIMEOUT = 2000;

function ParticipantTargetedReaction({ targetedReaction = null }) {
  const [showTargeted, setShowTargeted] = useState(!!targetedReaction);
  const [fadeClass, setFadeClass] = useState(false);
  const fadeTimerRef = useRef(null);
  const hideTimerRef = useRef(null);

  useEffect(() => {
    if (targetedReaction) {
      setShowTargeted(true);
      setFadeClass(true);

      fadeTimerRef.current = setTimeout(() => {
        setFadeClass(false);
      }, FADE_TIMEOUT);

      hideTimerRef.current = setTimeout(() => {
        setShowTargeted(false);
      }, TARGETED_REACTION_TIMEOUT);

      return () => {
        if (fadeTimerRef.current) {
          clearTimeout(fadeTimerRef.current);
          fadeTimerRef.current = null;
        }
        if (hideTimerRef.current) {
          clearTimeout(hideTimerRef.current);
          hideTimerRef.current = null;
        }
      };
    }
    return undefined;
  }, [targetedReaction]);

  if (!showTargeted || !targetedReaction) {
    return null;
  }

  return (
    <div className={scss.targetedReactionContainer}>
      <div
        className={cn(
          scss.targetedReactionBottomRight,
          fadeClass && scss.fade,
          showTargeted && scss.show
        )}
      >
        {targetedReaction}
      </div>
    </div>
  );
}

ParticipantTargetedReaction.propTypes = {
  targetedReaction: PropTypes.string,
};

export default ParticipantTargetedReaction;
